import { render, staticRenderFns } from "./CancelOrderModal.vue?vue&type=template&id=59faafcc&scoped=true&"
import script from "./CancelOrderModal.vue?vue&type=script&lang=js&"
export * from "./CancelOrderModal.vue?vue&type=script&lang=js&"
import style0 from "./CancelOrderModal.vue?vue&type=style&index=0&id=59faafcc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59faafcc",
  null
  
)

export default component.exports